import React from 'react'
import { Link } from 'react-router-dom'
const VideoGallery = () => {
  return (
    <>
    <div className="innerslide">
    <ul className="breadcrumb">
       <li><Link to="/"> Home</Link> </li>
       <li>  Gallery </li>
       <li> Video Gallery </li>
   </ul>
   </div>
   <div className="innersec">
   <div className="container">
   <div className="row">
     <div className="col-lg-6">
          <h1> Video Gallery </h1>
     </div>
      <div className="col-lg-6">
       <div className="chooseyear">
                 <select id="chooseddlYear">
                    <option selected="" value="Two">2023</option>
                    <option value="One">2022</option>
                 </select>
              </div>
      </div>
   </div> 
      <div className="clr"></div>
      <div id="showTwo" className="myDiv1 selected_year">
       <div className="row"> 
       <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12"> 
         <div className="video-gallery"> 
           <Link to="#" target="_blank">
             <i className="bi bi-play-circle-fill"></i> 
             <div> 
              <h3>Title</h3> 
              <p>27.02.2024</p> 
             </div> 
          </Link>
          </div>
       </div>
       <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12"> 
         <div className="video-gallery"> 
           <Link to="#" target="_blank">
             <i className="bi bi-play-circle-fill"></i> 
             <div> 
              <h3>Title</h3> 
              <p>27.02.2024</p> 
             </div> 
          </Link>
          </div>
       </div>
       <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12"> 
         <div className="video-gallery"> 
           <Link to="#" target="_blank">
             <i className="bi bi-play-circle-fill"></i> 
             <div> 
              <h3>Title</h3> 
              <p>27.02.2024</p> 
             </div> 
          </Link>
          </div>
       </div>
      </div>
      </div>
      <div id="showOne" className="myDiv1">
       <div className="row"> 
       <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12"> 
         <div className="video-gallery"> 
           <Link to="#" target="_blank">
             <i className="bi bi-play-circle-fill"></i> 
             <div> 
              <h3>Title</h3> 
              <p>27.02.2024</p> 
             </div> 
          </Link>
          </div>
       </div>
       <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12"> 
         <div className="video-gallery"> 
           <Link to="#" target="_blank">
             <i className="bi bi-play-circle-fill"></i> 
             <div> 
              <h3>Title</h3> 
              <p>27.02.2024</p> 
             </div> 
          </Link>
          </div>
       </div>
       <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12"> 
         <div className="video-gallery"> 
           <Link to="#" target="_blank">
             <i className="bi bi-play-circle-fill"></i> 
             <div> 
              <h3>Title</h3> 
              <p>27.02.2024</p> 
             </div> 
          </Link>
          </div>
       </div>
      </div>
      </div>
   </div>
   </div>
    </>
  )
}

export default VideoGallery
